<template>
  <div class="comboEdit">
    <el-dialog
      title="修改活动"
      :visible.sync="visible"
      class="comboSelect-dialog"
      width="480px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div v-show="actInfo.number" class="content-wrap">
          <div class="content-head">
            <div class="content-title">{{ actInfo.cseName }}</div>
            <div v-if="actInfo.cseType === 1" class="content-rules combo">套餐{{ actInfo.drugCount }}件{{ actInfo.price }}元</div>
            <div v-if="actInfo.cseType === 2" class="content-rules optional">任选{{ actInfo.drugCount }}件{{ actInfo.price }}元</div>
          </div>
          <div class="content-time">活动时间：{{ actInfo.startTime }} 至 {{ actInfo.endTime }}</div>
          <div class="content-qty-row">
            <div class="content-qty-row-left">
              <div class="content-qty-label">活动数量</div>
              <div class="content-qty-input-wrap">
                <div class="content-qty-input-wrap-minus" @click="actCountCalculate(-1)">-</div>
                <el-input class="content-qty-input" v-model="actInfo.count" @input="actCountInputIntegerFormat" @blur="actCountInputBlur"></el-input>
                <div class="content-qty-input-wrap-plus" @click="actCountCalculate(1)">+</div>
              </div>
            </div>
            <div v-if="actInfo.cseType === 2" class="content-qty-row-right">请选{{ optionalDrugCount }}件，已选{{ optionalSelectedCount }}件</div>
          </div>
          <div v-if="actInfo.physios.length > 0" class="content-table-block">
            <el-table
              :data="actInfo.physios"
              border
              :header-cell-style="{ background: '#F7F8F9', color: '#667182' }"
              style="width: 100%">
              <el-table-column prop="drugName" label="理疗项目" min-width="240" />
              <el-table-column prop="unit" label="单位" min-width="70" align="center" />
              <el-table-column label="数量" width="110">
                <template slot-scope="{ row }">
                  <div v-if="actInfo.cseType === 2" class="table-input-wrap">
                    <div class="table-input-wrap-minus" @click="comboItemNumCalculate(row, 'itemNum', -1)">-</div>
                    <el-input class="table-input" v-model="row.itemNum" @input="inputIntegerFormat($event, row, 'itemNum')"></el-input>
                    <div class="table-input-wrap-plus" @click="comboItemNumCalculate(row, 'itemNum', 1)">+</div>
                  </div>
                  <div v-if="actInfo.cseType === 1" class="table-wrap-num">{{ row.itemNum }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="actInfo.drugs.length > 0" class="content-table-block">
            <el-table
              :data="actInfo.drugs"
              border
              size="small"
              :header-cell-style="{ background: '#F7F8F9', color: '#667182' }"
              style="width: 100%">
              <el-table-column prop="drugName" label="普通商品" min-width="140" />
              <el-table-column prop="specifications" label="规格" min-width="100" />
              <el-table-column prop="unit" label="单位" width="70"/>
              <el-table-column label="数量" width="110">
                <template slot-scope="{ row }">
                  <div v-if="actInfo.cseType === 2" class="table-input-wrap">
                    <div class="table-input-wrap-minus" @click="comboItemNumCalculate(row, 'itemNum', -1)">-</div>
                    <el-input class="table-input" v-model="row.itemNum" @input="inputIntegerFormat($event, row, 'itemNum')"></el-input>
                    <div class="table-input-wrap-plus" @click="comboItemNumCalculate(row, 'itemNum', 1)">+</div>
                  </div>
                  <div v-if="actInfo.cseType === 1" class="table-wrap-num">{{ row.itemNum }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :disabled="!actInfo.number || (actInfo.cseType === 2 && (optionalSelectedCount !== optionalDrugCount))" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getComboSaleInfo } from '@/api/campaign'
  export default {
    name: 'comboSelect',
    props: {
      doctorId: {
        type: [String, Number],
        default: ''
      }
    },
    data () {
      return {
        visible: false,
        actInfo: {
          number: '',
          cseName: '',
          cseType: 1,
          drugCount: 0,
          price: 0,
          count: 1,
          startTime: '',
          endTime: '',
          physios: [],
          drugs: []
        }
      }
    },
    computed: {
      optionalDrugCount () {
        return (this.actInfo.count || 1) * this.actInfo.drugCount
      },
      optionalSelectedCount () {
        const physiosCount = this.actInfo.physios.reduce((total, item) => {
          return total + (Number(item.itemNum) || 0)
        }, 0)
        const drugsCount = this.actInfo.drugs.reduce((total, item) => {
          return total + (Number(item.itemNum) || 0)
        }, 0)
        return physiosCount + drugsCount
      }
    },
    methods: {
      actInfoInit () {
        this.actInfo.number = ''
        this.actInfo.cseName = ''
        this.actInfo.cseType = 1
        this.actInfo.drugCount = 0
        this.actInfo.price = 0
        this.actInfo.count = 1
        this.actInfo.startTime = ''
        this.actInfo.endTime = ''
        this.actInfo.physios = []
        this.actInfo.drugs = []
      },
      open (activity) {
        if (activity) {
          this.getActInfo(JSON.parse(JSON.stringify(activity)))
          this.visible = true
        }
      },
      close () {
        this.visible = false
        this.actLabel = 2
        this.actInfoInit()
      },
      async getActInfo (activity) {
        const res = await getComboSaleInfo({
          cseCode: activity.actNumber
        })
        if (res.code === 200) {
          this.actInfo.number = res.data.cseCode
          this.actInfo.cseName = res.data.cseName
          this.actInfo.cseType = res.data.cseType
          this.actInfo.drugCount = res.data.drugCount || 0
          this.actInfo.price = res.data.price || 0
          this.actInfo.count = activity.actCount
          this.actInfo.startTime = new Date(res.data.startTime).Format('yyyy-MM-dd hh:mm')
          this.actInfo.endTime = new Date(res.data.endTime).Format('yyyy-MM-dd hh:mm')
          this.actInfo.physios = res.data.physios && res.data.physios.map(v => {
            const activityItem = activity.items.find(item => { return item.csdId === v.csdId })

            if (activityItem) {
              v['itemNum'] = activityItem.itemNum
              v['executeCount'] = activityItem.executeCount
              v['executeDesc'] = activityItem.executeDesc
              v['executeInterval'] = activityItem.executeInterval
              v['remark'] = activityItem.remark
              v['physioExtendJson'] = activityItem.physioExtendJson
            } else {
              v['itemNum'] = 0
              if (res.data.cseType === 1) {
                v.itemNum = v.quantity
              }
            }
            return v
          }) || []
          this.actInfo.drugs = res.data.drugs && res.data.drugs.map(v => {
            const activityItem = activity.items.find(item => { return item.csdId === v.csdId })

            if (activityItem) {
              v['itemNum'] = activityItem.itemNum
            } else {
              v['itemNum'] = 0
              if (res.data.cseType === 1) {
                v.itemNum = v.quantity
              }
            }
            
            return v
          }) || []
        }
      },
      actCountInputIntegerFormat(value) {
        this.actInfo.count = String(value || '').replace(/[^\d]/g, '')
      },
      actCountInputBlur () {
        if (!this.actInfo.count || this.actInfo.count < 1) {
          this.actInfo.count = 1
        }
        if (this.actInfo.cseType === 1) {
          this.actInfo.physios.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
          this.actInfo.drugs.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
        }
        
      },
      actCountCalculate (value) {
        let count = this.actInfo.count + Number(value)
        if (count < 1) {
          count = 1
        }
        this.actInfo.count = count
        if (this.actInfo.cseType === 1) {
          this.actInfo.physios.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
          this.actInfo.drugs.map(v => {
            v.itemNum = (this.actInfo.count || 1) * v.quantity
          })
        }
      },
      inputIntegerFormat (value, row, key) {
        row[key] = String(value || '').replace(/[^\d]/g, '')
      },
      comboItemNumCalculate (row, key, value) {
        let num = Number(row[key]) + Number(value)
        if (num < 0) {
          num = 0
        }
        row[key] = num
      },
      submit () {
        this.$emit('submit', JSON.parse(JSON.stringify(this.actInfo)))
      }
    }
  }
</script>

<style lang="less" scoped>
  .comboSelect-dialog /deep/ .el-dialog__header {
    display: block !important;
    padding: 12px 24px;
  }

  .comboSelect-dialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .comboSelect-dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 12px;
  }

  .comboSelect-dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .comboSelect-dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 440px;
    overflow: hidden;
  }

  .content-wrap {
    box-sizing: border-box;
    flex-grow: 1;
    padding: 16px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .content-head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .content-title {
    line-height: 22px;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }

  .content-rules {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0 8px;
    height: 24px;
    font-size: 13px;
    border-radius: 2px;
  }

  .content-rules.combo {
    color: #1890FF;
    background-color: #E8F4FF;
  }

  .content-rules.optional {
    color: #29C01B;
    background-color: #E2F8E0;
  }

  .content-time {
    margin: 4px 0 0 0;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .content-qty-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .content-qty-row-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .content-qty-label {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .content-qty-input-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 12px;
  }

  .content-qty-input-wrap-minus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 18px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 2px 0 0 2px;
    cursor: pointer;
    user-select: none;
  }

  .content-qty-input-wrap-plus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 0 2px 2px 0;
    cursor: pointer;
    user-select: none;
  }

  .content-qty-input {
    margin: 0 -1px;
    width: 48px;
    height: 24px;
  }

  .content-qty-input /deep/ .el-input__inner {
    padding: 0 6px;
    height: 24px;
    text-align: center;
  }

  .content-qty-row-right {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .content-table-block {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .table-input-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table-input-wrap-minus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 18px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 2px 0 0 2px;
    cursor: pointer;
    user-select: none;
  }

  .table-input-wrap-plus {
    box-sizing: border-box;
    width: 26px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    font-size: 20px;
    color: #909399;
    background-color: #F0F1F3;
    border: 1px solid #E0E0E0;
    border-radius: 0 2px 2px 0;
    cursor: pointer;
    user-select: none;
  }

  .table-input {
    margin: 0 -1px;
    width: 40px;
    height: 24px;
  }

  .table-input /deep/ .el-input__inner {
    padding: 0 6px;
    height: 24px;
    text-align: center;
  }

  .table-wrap-num {
    font-size: 14px;
    color: #000000;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 18px;
    width: 100%;
    border-top: 1px solid #E0E0E0;
  }
</style>